import { DeceasedClient, DeceasedWorkflowClient } from '@frontend/deceased/api';
import { IDeceased, UpdateDeceased, UpdateDeceasedState } from '@frontend/deceased/types';
import { ToastUtil } from '@frontend/toast-utils';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface ViewProps {
    navigate: ReturnType<typeof useNavigate>;
    detailVersion: number;
    setObject: React.Dispatch<React.SetStateAction<IDeceased | null>>;
    updateWorkflow: UpdateDeceased | null;
    setUpdateWorkflow: React.Dispatch<React.SetStateAction<UpdateDeceased | null>>;
    onUpdateWorkflow: () => void;
    updateState: UpdateDeceasedState | null;
    setUpdateState: React.Dispatch<React.SetStateAction<UpdateDeceasedState | null>>;
    onUpdateState: () => void;
}

export const useDeceasedDetail = (): ViewProps => {
    const navigate = useNavigate();
    const [object, setObject] = useState<IDeceased | null>(null);
    const [updateWorkflow, setUpdateWorkflow] = useState<UpdateDeceased | null>(null);
    const [updateState, setUpdateState] = useState<UpdateDeceasedState | null>(null);
    const [detailVersion, setDetailVersion] = useState(0);
    const refreshDetail = () => setDetailVersion((version) => version + 1);

    const onUpdateWorkflow = () => {
        if (updateWorkflow === null) {
            setUpdateWorkflow({ workflow_id: object?.workflow_id });
            return;
        }

        ToastUtil.promise(
            () => DeceasedClient.patchDeceased(object!.account_id, object!.id, updateWorkflow),
            { title: 'Updating Deceased Workflow' },
            { title: 'Deceased Workflow Updated', onSuccess: refreshDetail },
            { title: 'Deceased Workflow Update Failed' }
        );
        setUpdateWorkflow(null);
    };

    const onUpdateState = () => {
        if (updateState === null) {
            setUpdateState({ state: object?.state });
            return;
        }

        ToastUtil.promise(
            () => DeceasedWorkflowClient.updateDeceasedState(object!.account_id, object!.id, updateState.state!),
            { title: 'Updating Deceased State' },
            { title: 'Deceased State Updated', onSuccess: refreshDetail },
            { title: 'Deceased State Update Failed' }
        );
        setUpdateState(null);
    };

    return {
        navigate,
        detailVersion,
        setObject,
        updateWorkflow,
        setUpdateWorkflow,
        onUpdateWorkflow,
        updateState,
        setUpdateState,
        onUpdateState
    };
};
